export default __webpack_public_path__ + "static/media/welc1.39edea3a.gif";